import _styled from "@emotion/styled/base";
function _EMOTION_STRINGIFIED_CSS_ERROR__() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const Center = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "e1tcu5uz0"
} : {
  target: "e1tcu5uz0",
  label: "Center"
})(process.env.NODE_ENV === "production" ? {
  name: "193h5r6",
  styles: "text-align:center;margin:auto"
} : {
  name: "193h5r6",
  styles: "text-align:center;margin:auto/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi9hcHAvbm9kZV9tb2R1bGVzL0BpbnRlcm5lc3Mvd2ViLWNvcmUvc3JjL2NvbXBvbmVudHMvc3RydWN0dXJlL0NlbnRlci9DZW50ZXIuanMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBRXlCIiwiZmlsZSI6Ii9hcHAvbm9kZV9tb2R1bGVzL0BpbnRlcm5lc3Mvd2ViLWNvcmUvc3JjL2NvbXBvbmVudHMvc3RydWN0dXJlL0NlbnRlci9DZW50ZXIuanMiLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgc3R5bGVkIGZyb20gJ0BlbW90aW9uL3N0eWxlZCc7XG5cbmNvbnN0IENlbnRlciA9IHN0eWxlZC5kaXZgXG4gIHRleHQtYWxpZ246IGNlbnRlcjtcbiAgbWFyZ2luOiBhdXRvO1xuYDtcblxuZXhwb3J0IGRlZmF1bHQgQ2VudGVyOyJdfQ== */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
});
export default Center;